import { PlusOutlined } from "@ant-design/icons";
import type { InputRef } from "antd";
import { Input, Tag } from "antd";
import { FormInstance } from "antd/es/form/Form";
import React, { useEffect, useRef, useState } from "react";
import styles from "./index.css";

type Props = {
  form: FormInstance;
  currentPhases?: string[];
};

const tabStyle = {
  fontSize: "1.7rem",
  textalign: "center",
};

export const ParentPhases: React.FC<Props> = ({ form, currentPhases }) => {
  const [tags, setTags] = useState<string[]>(currentPhases ?? []);
  const [inputVisible, setInputVisible] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  useEffect(() => {
    setTags(currentPhases ?? []);
  }, [currentPhases]);

  useEffect(() => {
    form.setFieldsValue({ parentPhases: tags });
  }, [tags]);

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue("");
  };

  const forMap = (tag: string) => {
    const tagElem = (
      <Tag
        style={{ ...tabStyle, marginBottom: "10px" }}
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    );
    return (
      <span key={tag} style={{ display: "inline-block" }}>
        {tagElem}
      </span>
    );
  };

  const tagChild = tags.map(forMap);
  return (
    <div style={{}}>
      <div style={tabStyle}>{tagChild}</div>
      {inputVisible && (
        <Input
          ref={inputRef}
          type="text"
          size="middle"
          style={{ width: 90 }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {!inputVisible && (
        <Tag style={{ ...tabStyle }} onClick={showInput} className={styles["site-tag-plus"]}>
          <span>
            <PlusOutlined /> Add Phase
          </span>
        </Tag>
      )}
    </div>
  );
};
